export enum TableFieldNames {
  PropertyName = 'propertyName',
  QuoteItemIdentifier = 'quoteItemIdentifier',
  SourceValue = 'sourceValueFormatted',
  TargetValue = 'targetValueFormatted',
}

export const tableColumns = [
  {
    field: TableFieldNames.PropertyName,
    headerName: 'Name',
    width: '40%',
  },
  {
    field: TableFieldNames.QuoteItemIdentifier,
    headerName: 'Quote Item',
    width: '20%',
  },
  {
    field: TableFieldNames.SourceValue,
    headerName: 'Old Value',
    width: '20%',
  },
  {
    field: TableFieldNames.TargetValue,
    headerName: 'New Value',
    width: '20%',
  },
];

export enum FormChangeFieldNames {
  FormName = 'formName',
  Change = 'change',
}

export const formChangeColumns = [
  {
    field: FormChangeFieldNames.FormName,
    headerName: 'Form Name',
    width: '70%',
  },
  {
    field: FormChangeFieldNames.Change,
    headerName: 'Change',
    width: '30%',
  },
];

export const getTableColumns = (isExternalUser: boolean) => {
  if (isExternalUser) {
    return tableColumns.filter((col) => col.field !== TableFieldNames.QuoteItemIdentifier);
  }
  return tableColumns;
};

export const data = [
  {
    name: 'Inland Marine',
    quoteItem: 'Policy',
    oldValue: undefined,
    newValue: 'Yes',
  },
  {
    name: 'Mailing Street',
    quoteItem: 'Name Insured',
    oldValue: '123 Test Street',
    newValue: '133 Test Street',
  },
  {
    name: 'Inland Marine',
    quoteItem: 'Policy',
    oldValue: undefined,
    newValue: 'Yes',
  },
  {
    name: 'Mailing Street',
    quoteItem: 'Name Insured',
    oldValue: '123 Test Street',
    newValue: '133 Test Street',
  },
  {
    name: 'Inland Marine',
    quoteItem: 'Policy',
    oldValue: undefined,
    newValue: 'Yes',
  },
  {
    name: 'Mailing Street',
    quoteItem: 'Name Insured',
    oldValue: '123 Test Street',
    newValue: '133 Test Street',
  },
];
